import React, { useContext, useState, useEffect } from 'react';
import store from '../../store';
import { updateUISettings } from '../../constants/UISettings';
import {isUserAnonymous} from '../../constants/verifications';
// Material components
import {
    ListItem,
    ListItemText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Input
} from '@material-ui/core';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { colors, fonts } from '../../assets/jss'
const useStyles = makeStyles((theme) => ({
    settingsList: {
        backgroundColor: 'white',
        color: 'black'
    },
    listItem: {
        paddingLeft: 12
    },
    header: {
        ...fonts.secondary
    },
    formControl: {
        minWidth: 150
    },
    menuItem: {
        color: 'white'
    }
}));


export default () => {
    const classes = useStyles();
    const { state, profile } = useContext(store);
    const [appBarBackgroundColor, setAppBarBackgroundColor] = useState('');

    const backgroundColorsNames = Object.keys(colors);

    const handleAppBarBackground = (e) => {
        if (isUserAnonymous(state.user.isAnonymous)) {
            return;
        }
        let color = e.target.value;
        setAppBarBackgroundColor(color);
        updateUISettings(state.user.uid, profile, 'appBarBackground', colors[color])
    }

    const handleHeaderBackground = (e) => {
        if (isUserAnonymous(state.user.isAnonymous)) {
            return;
        }
        let color = e.target.value;
        updateUISettings(state.user.uid, profile, 'Primary Background', color)
    }

    return (
        <React.Fragment>
            <ListItem>
                <ListItemText className={classes.listItem}>
                    Appbar Background
                </ListItemText>
                <FormControl className={classes.formControl}>
                    <InputLabel id="select-appbarBG-color">Select color</InputLabel>
                    <Select
                        id="select-appbarBG"
                        labelId="select-appbarBG-color"
                        value={appBarBackgroundColor}
                        onChange={handleAppBarBackground}>
                        {backgroundColorsNames.map((color, i) =>
                            <MenuItem
                                key={i}
                                value={color}
                                className={classes.menuItem}
                                style={{ backgroundImage: colors[color] }} >
                                {color}
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>              
            </ListItem>
            <ListItem>
                <ListItemText className={classes.listItem}>
                    Header background
                </ListItemText>
                <FormControl className={classes.formControl}>
                    <InputLabel id="select-BG-color">Select color</InputLabel>
                    <Input
                        id="BG-color"
                        labelid="select-BG-color"
                        type='color'
                        value={profile.settings["Primary Background"]}
                        onChange={handleHeaderBackground}>                        
                    </Input>
                </FormControl>           
            </ListItem>
        </React.Fragment>
    )
}